/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationSettings } from './IntegrationSettings';
import {
    IntegrationSettingsFromJSON,
    IntegrationSettingsFromJSONTyped,
    IntegrationSettingsToJSON,
    IntegrationSettingsToJSONTyped,
} from './IntegrationSettings';

/**
 * 
 * @export
 * @interface FindOneIntegrationSettingsByFacilityId200Response
 */
export interface FindOneIntegrationSettingsByFacilityId200Response {
    /**
     * 
     */
    data?: IntegrationSettings;
}

/**
 * Check if a given object implements the FindOneIntegrationSettingsByFacilityId200Response interface.
 */
export function instanceOfFindOneIntegrationSettingsByFacilityId200Response(value: object): value is FindOneIntegrationSettingsByFacilityId200Response {
    return true;
}

export function FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(json: any): FindOneIntegrationSettingsByFacilityId200Response {
    return FindOneIntegrationSettingsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindOneIntegrationSettingsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneIntegrationSettingsByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : IntegrationSettingsFromJSON(json['data']),
    };
}

export function FindOneIntegrationSettingsByFacilityId200ResponseToJSON(json: any): FindOneIntegrationSettingsByFacilityId200Response {
    return FindOneIntegrationSettingsByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindOneIntegrationSettingsByFacilityId200ResponseToJSONTyped(value?: FindOneIntegrationSettingsByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': IntegrationSettingsToJSON(value['data']),
    };
}

